import React from 'react';
import './expireModal.scss';
import { Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const WarningModal = (props) => {
    const history = useHistory();
    const openPayment = () => {
        history.push('/account?tab=plans')
    }
    return (
        <div>
            {/* ############## Expire Alert Modal ############### */}
            <Modal
                show={props.planAlert}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={props.closeSubModal}
                dialogClassName={"expire-modal"}
            >
                <div className="disable-post-content1">
                    <h3 className="py-3" style={{ fontSize: 18 }}>
                        {localStorage.getItem('role')?.includes('admin') ?
                            'This feature is not available for your current plan.' :
                            'This feature is not available for your current plan.Please contact admin'}</h3>
                    {
                        localStorage.getItem('role')?.includes('admin') ?
                            <button className="primaryButton" onClick={() => {
                                openPayment();
                                props.closeSubModal();
                            }}>
                                Upgrade now
                            </button> :
                            <button className="primaryButton" onClick={() => props.closeSubModal()}>
                                Ok
                            </button>
                    }

                </div>
            </Modal>
        </div>
    )
}

export default WarningModal;
